import React, { useState } from "react";
import "./hero.css";
import CaretRightIcon from "../icons/CaretRightIcon";
import Header1 from "../../assets/Header1.png";
import { useMediaQuery } from "react-responsive";
import FormClienteModal from "../modals/FormClienteModal";

const Hero = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isMobile ? (
        <div className="hero-mobile">
          <div className="hero-content-mobile">
            <img className="img-mobile" src={Header1} alt="" />
            <p>
              Siempre en movimiento <br /> para que tu negocio no pare.
            </p>
            <button
              type="button"
              onClick={() => setIsOpen(true)}
              className="hero-button-mobile d-flex flex-row align-items-center justify-content-between"
            >
              Quiero ser cliente
              <span className="icon-wrapper">
                <CaretRightIcon size={16} color="currentColor" />
              </span>
            </button>
          </div>
        </div>
      ) : (
        <div className="hero">
          <div className="hero-content-l">
            <p className="mb-0">
              Siempre en movimiento
              <br /> para que tu negocio no pare.
            </p>
            <button
              type="button"
              className="hero-button d-flex flex-row align-items-center justify-content-between"
              onClick={() => setIsOpen(true)}
            >
              Quiero ser cliente
              <span className="icon-wrapper">
                <CaretRightIcon size={16} color="currentColor" />
              </span>
            </button>
          </div>
          <div className="hero-content-r">
            <img src={Header1} alt="" />
          </div>
        </div>
      )}
      <FormClienteModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default Hero;
